var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCounter3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 98,
    viewBox: "0 0 100 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 95.8332C37.5 83.1249 42.5483 70.9371 51.5345 61.951C60.5206 52.9649 72.7084 47.9165 85.4167 47.9165H97.9167",
    stroke: "#E8AD15",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0834 95.8332C27.0238 86.5695 29.3025 77.4406 33.7084 69.2915",
    stroke: "#E8AD15",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5834 95.8332C14.5238 86.5695 16.8025 77.4406 21.2084 69.2915",
    stroke: "#E8AD15",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08335 95.8332C2.02381 86.5695 4.30246 77.4406 8.70835 69.2915",
    stroke: "#E8AD15",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9167 95.8335C47.9167 85.8879 51.8676 76.3496 58.9002 69.317C65.9328 62.2844 75.4711 58.3335 85.4167 58.3335H93.75",
    stroke: "#E8AD15",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M58.3333 95.8333C58.3333 88.6504 61.1867 81.7616 66.2658 76.6825C71.3449 71.6034 78.2337 68.75 85.4166 68.75H89.5833",
    stroke: "#E8AD15",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M45.8333 47.9165H85.4166",
    stroke: "#E8AD15",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3334 39.5833C89.0863 39.5833 93.75 34.9196 93.75 29.1667C93.75 23.4137 89.0863 18.75 83.3334 18.75C77.5804 18.75 72.9167 23.4137 72.9167 29.1667C72.9167 34.9196 77.5804 39.5833 83.3334 39.5833Z",
    stroke: "#E8AD15",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M83.3334 33.3335V45.8335",
    stroke: "#E8AD15",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M56.25 22.9168C62.0029 22.9168 66.6666 18.2531 66.6666 12.5002C66.6666 6.7472 62.0029 2.0835 56.25 2.0835C50.497 2.0835 45.8333 6.7472 45.8333 12.5002C45.8333 18.2531 50.497 22.9168 56.25 22.9168Z",
    stroke: "#E8AD15",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.25 16.6665V45.8332",
    stroke: "#E8AD15",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25 47.9168C30.7529 47.9168 35.4166 43.2531 35.4166 37.5002C35.4166 31.7472 30.7529 27.0835 25 27.0835C19.247 27.0835 14.5833 31.7472 14.5833 37.5002C14.5833 43.2531 19.247 47.9168 25 47.9168Z",
    stroke: "#E8AD15",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M25 41.6665V58.3332",
    stroke: "#E8AD15",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 58.3335H54.1667",
    stroke: "#E8AD15",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08331 68.75H43.75",
    stroke: "#E8AD15",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCounter3);
export default __webpack_public_path__ + "static/media/counter3.27f08c33a74114c90a4d24d7b4ae05e0.svg";
export { ForwardRef as ReactComponent };